import React from "react";
import "./WeDealsIn.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container } from "react-bootstrap";

const imageSources = [
  "https://airhex.com/images/airline-logos/alt/aeroflot.png",
  "https://airhex.com/images/airline-logos/alt/aerolineas-argentinas.png",
  "https://airhex.com/images/airline-logos/alt/aeromexico.png",
  "https://airhex.com/images/airline-logos/alt/air-canada.png",
  "https://airhex.com/images/airline-logos/alt/air-china.png",
  "https://airhex.com/images/airline-logos/alt/air-france.png",
  "https://airhex.com/images/airline-logos/alt/air-new-zealand.png",
  "https://airhex.com/images/airline-logos/alt/all-nippon-airways.png",
  "https://airhex.com/images/airline-logos/alt/american-airlines.png",
  "https://airhex.com/images/airline-logos/alt/asiana-airlines.png",
  "https://airhex.com/images/airline-logos/alt/british-airways.png",
  "https://airhex.com/images/airline-logos/alt/cathay-pacific.png",
  "https://airhex.com/images/airline-logos/alt/china-southern-airlines.png",
  "https://airhex.com/images/airline-logos/alt/copa-airlines.png",
  "https://airhex.com/images/airline-logos/alt/delta-air-lines.png",
  "https://airhex.com/images/airline-logos/alt/el-al.png",
  "https://airhex.com/images/airline-logos/alt/eva-air.png",
  "https://airhex.com/images/airline-logos/alt/egyptair.png",
  "https://airhex.com/images/airline-logos/alt/emirates.png",
  "https://airhex.com/images/airline-logos/alt/ethiopian-airlines.png",
  "https://airhex.com/images/airline-logos/alt/flydubai.png",
  "https://airhex.com/images/airline-logos/alt/hainan-airlines.png",
  "https://airhex.com/images/airline-logos/alt/iberia.png",
  "https://airhex.com/images/airline-logos/alt/japan-airlines.png",
  "https://airhex.com/images/airline-logos/alt/klm.png",
  "https://airhex.com/images/airline-logos/alt/kenya-airways.png",
  "https://airhex.com/images/airline-logos/alt/korean-air.png",
  "https://airhex.com/images/airline-logos/alt/lufthansa.png",
  "https://airhex.com/images/airline-logos/alt/qantas.png",
  "https://airhex.com/images/airline-logos/alt/qatar-airways.png",
  "https://airhex.com/images/airline-logos/alt/royal-air-maroc.png",
  "https://airhex.com/images/airline-logos/alt/swiss-international-air-lines.png",
  "https://airhex.com/images/airline-logos/alt/singapore-airlines.png",
  "https://airhex.com/images/airline-logos/alt/tui-airways.png",
  "https://airhex.com/images/airline-logos/alt/turkish-airlines.png",
  "https://airhex.com/images/airline-logos/alt/united-airlines.png",
  "https://airhex.com/images/airline-logos/alt/vietnam-airlines.png",
  "https://airhex.com/images/airline-logos/alt/virgin-atlantic.png",
  "https://airhex.com/images/airline-logos/alt/xiamen-airlines.png",
  "https://airhex.com/images/airline-logos/alt/avianca.png"
];

const WeDealsIn = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 7,   
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 5 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  return (
    <section className="weDealsIn-section">
      <Container>
        <div className="weDealsIn-container">
          <div className="weDealsIn-header">
            <h2 className="weDealsIn-heading">Airlines We Deal In</h2>
            <div className="weDealsIn-line"></div>
          </div>
          
          <div className="weDealsIn-slider-wrapper">
            <Slider {...settings}>
              {imageSources.map((partner, index) => (
                <div key={index} className="weDealsIn-slider-item">
                  <div className="weDealsIn-img-card">
                    <img
                      className="weDealsIn-partnerImg"
                      src={partner}
                      alt={`Airline Partner ${index + 1}`}
                      loading="lazy"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default WeDealsIn;
